import React from 'react'

const BlogContent = ({data}) => {
  return data ? (
    <div className="blog-content" dangerouslySetInnerHTML={{__html: data}} />
  ) : (
    <div className="blog-content">
      <p>
        <img src="/images/khub_program_detail.jpg" alt="program"/>
      </p>
      <h6>
        <b>Maraknya ketegangan dan konflik sosial dalam dasawarsa terakhir ini semakin menimbulkan banyak masalah, mulai dari pilihan politik yang beda, suku, agama, status sosial bahkan ketimpangan gender. Ketegangan sosial atau bahkan konflik adalah hal yang biasa dan menjadi dinamika dalam kehidupan bermasyarakat, hal ini akan menjadi masalah dan semakin rumit tatkala adanya kebuntuan komunikasi antar pemangku kepentingan dan rendahnya nilai trust , serta menguatnya prasangka dan streortype di sistem sosial kemasyarakatan.</b>
      </h6>
      <p>
      Untuk menjawab persoalan diatas, PeaceGen menginisiasi program Breaking Down the Walls (BDW). Salah satu program PeaceGeneration Indonesia sebagai platform perjumpaan dua komunitas yang berbeda untuk saling belajar, mendengarkan, dan menciptakan rasa aman untuk saling berdialog atas kondisi ketegangan dan konflik dengan memulai membagun rasa percaya [trust], meruntuhkan tembok prasangka untuk menginisiasi persahabatan dan kekeluargaan dalam bingkai damai.
      <br /><br />
      BDW juga sebagai platform untuk menumbuhkan dan merawat toleransi dan budaya damai serta pemahaman keragaman dalam bingkai persatuan Indonesia dan kemanusiaan.
      <br /><br />
      Program BDW tahun 2019-2020 akan terfokus di dua kota, yakni Kota Solo dan Palu yang masing-masing akan dilaksanakan oleh tim chapter Agent of Peace Solo dan Palu. masing-masing chapter akan berkolaborasi dengan dua sekolah berbasis Islam dan Kristen. Untuk Kota Solo program akan dilaksanakan dengan kolaborasi antar Sekolah Muhammadiyah SIMPON dan SMP Regina Pacis Ursulin Kota Solo, sementara di Kota Palu berkolaborasi dengan SMA Muhammadiyah dan SMA K GKST Imanuel Kota Palu.
      </p>
    </div>
  )
}

export { BlogContent }
